// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__3XXxc"};